// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"643":"065a9f7d","882":"065a9f7d"}[chunkId] + ".chunk.css";
};